import { useState } from 'react'
import ButtonDropdownOption from './button-dropdown-option'
import { GridiconsSearch } from '../../assets/icon/iconify'
import { DropdownOption } from '../../features/auth/auth-state';

interface Props {
    searchType: DropdownOption | null;
    setSearchType: (value: DropdownOption) => void;
    searchValue: string;
    setSearchValue: (value: string) => void;
    options: DropdownOption[];
}

export default function SearchFilterBar({ options, searchType, setSearchType, searchValue, setSearchValue }: Props) {
    
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    
    return (
        <div className="bg-white rounded space-y-2">
            <div className="flex justify-between">
                <div className="flex space-x-2 w-full max-w-[500px]">
                    <ButtonDropdownOption 
                        options={options} 
                        value={searchType} 
                        onChange={setSearchType}
                        open={openDropdown === 'search'}
                        setOpen={() => setOpenDropdown(openDropdown === 'search' ? null : 'search')}
                    />
                    <div className='relative w-full flex'> 
                        <div className='absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400'>
                            <GridiconsSearch height={18} width={18}/>
                        </div> 
                        <input 
                            className={`border w-full text-xs rounded-lg px-2 py-1 focus:outline-none pl-9 pr-3 
                            ${ searchValue.length > 1
                                ? 'border-[#186cb2] bg-[#186cb2]/10'
                                : 'border-gray-300'
                            }`}
                            type="text" 
                            placeholder={`Search by ${searchType?.name}`}
                            value={searchValue} 
                            onChange={(e) => setSearchValue(e.target.value)} 
                        /> 
                    </div>
                </div>
            </div>
        </div>
    )
}
